import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrModalComponent, BrModalConfig, BrModalActionEvent, TalentGatewayBrandingPayload, BrandingRuntimeService, TalentGatewayBrandingAdapter } from '@brassring-ics/br-ui-wrapper';
import { stubTrue } from 'lodash';
import { TgSettingsService } from 'app/services/TG-Setting_Services/tg-settings.service';

@Component({
  selector: 'app-common-warepper-dialogue',
  standalone: true, 
  imports: [BrModalComponent], // Added the component to the imports array
  templateUrl: './common-warepper-dialogue.component.html',
  styleUrl: './common-warepper-dialogue.component.scss'
})
export class CommonWarepperDialogueComponent implements OnInit, OnChanges {
  
  @Input() config!: BrModalConfig;

  @Output() action = new EventEmitter<BrModalActionEvent>();
  @Output() close = new EventEmitter<void>();
 
  // 1. Declare the property type at the class level
talentGatewayBranding!: TalentGatewayBrandingPayload;
  constructor(private readonly brandingRuntimeService: BrandingRuntimeService,private readonly tgsettingsService: TgSettingsService) { }
  ngOnInit(): void {
    
    console.log('CommonWarepperDialogueComponent initialized' + JSON.stringify(this.config));
        // toBrBrandingConfig does not exist on BrandingRuntimeService — pass the payload directly
   
    const styles = this.tgsettingsService.getBrandingConfig && typeof this.tgsettingsService.getBrandingConfig === 'function' 
        ? this.tgsettingsService.getBrandingConfig() 
        : null;
        this.talentGatewayBranding = {
        Responsive_BackgroundColor: styles?.bg , // Use fallback color if styles or bg is missing
      
        Responsive_BaseFontColor: styles?.text,
        Responsive_BaseFontFamily: styles?.font,
        Responsive_BaseFontSize: '16px',
        Responsive_ButtonBackgroundColor: styles?.focus,
    };
     this.brandingRuntimeService.setBranding(TalentGatewayBrandingAdapter.toBrBrandingConfig(this.talentGatewayBranding));
  }
  


  ngOnChanges(changes: SimpleChanges): void {
    console.log('Input changed', changes);
  }
  onAction(event: BrModalActionEvent): void {
    this.action.emit(event);
  }

  onClose(): void {
    this.close.emit();
  }
}